export const DOMAIN = {
  beta: 'test',
  gamma: 'test',
  prod: 'prod',
}

export const REALM = {
  'eu-west-1': 'EUAmazon',
  'us-east-1': 'NAAmazon',
  'us-west-2': 'FEAmazon',
}

export const SITE = {
  beta: 'FIT.Beta',
  gamma: 'FIT.Gamma',
  prod: 'FIT',
}

export const Total = 'Total'
export const Success = 'Success'
export const Failure = 'Failure'

export const AAC_FIT_DISMISSED_WIDGETS = 'AAC_FIT_DISMISSED_WIDGETS'
export const AAC_FIT_DISMISSED_ALERT_WIDGETS = 'AAC_FIT_DISMISSED_ALERT_WIDGETS'
export const AAC_FIT_DISMISSED_WHATS_NEW_WIDGETS = 'AAC_FIT_DISMISSED_WHATS_NEW_WIDGETS'

export enum WidgetTypes {
  ExpandedPageBanner = 'ExpandedPageBanner',
  FeatureIntroductionAlert = 'FeatureIntroductionAlert',
  FeatureModalDesktop = 'FeatureModalDesktop',
  FeatureModalMobile = 'FeatureModalMobile',
  LaunchTag = 'LaunchTag',
  DesktopLaunchModal = 'DesktopLaunchModal',
  MobileLaunchModal = 'MobileLaunchModal',
  AnchoredAlertDesktop = 'AnchoredAlertDesktop',
  AnchoredAlertMobile = 'AnchoredAlertMobile',
  WhatsNewCenterItem = 'WhatsNewCenterItem',
  WhatsNewCenter = 'WhatsNewCenter',
}

export enum WeblabedFeatures {
  AAC_WEBLAB_TEST = 'AAC_WEBLAB_TEST', // This weblab doesn't exist and is only used for testing purposes
}
